"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ContactInfo;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _Avatar = _interopRequireDefault(require("../../components/Avatar"));
var _reactI18next = require("react-i18next");
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function UnblockTip(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var isDomain = props.isDomain;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-secondary text-center w-full p-4 text-xs mt-2"
  }, !isDomain ? t('contactDetail.unblockTip') : t('contactDetail.unblockTip.domain'), ' ', /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, props, {
    className: "font-semibold text-primary"
  }), t('button.unblock')));
}
function BlockButton(props) {
  var isDomain = props.isDomain;
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, props, {
    className: "text-primary text-xs font-semibold"
  }), isDomain ? t('button.blockDomain') : t('button.blockSender'));
}
function HideImagesButton(props) {
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation3.t;
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, props, {
    className: "text-primary text-xs font-semibold"
  }), t('button.hideImages'));
}
function ContactInfo(_ref) {
  var name = _ref.name,
    email = _ref.email,
    avatar = _ref.avatar,
    blocked = _ref.blocked,
    onBlock = _ref.onBlock,
    onUnblock = _ref.onUnblock,
    onHideImages = _ref.onHideImages,
    disabled = _ref.disabled,
    _ref$isDomain = _ref.isDomain,
    isDomain = _ref$isDomain === void 0 ? false : _ref$isDomain,
    _ref$showBlockAction = _ref.showBlockAction,
    showBlockAction = _ref$showBlockAction === void 0 ? true : _ref$showBlockAction,
    _ref$showHideImageAct = _ref.showHideImageAction,
    showHideImageAction = _ref$showHideImageAct === void 0 ? false : _ref$showHideImageAct;
  var blockAction = (0, _react.useMemo)(function () {
    if (showBlockAction) {
      if (blocked) {
        return /*#__PURE__*/_react["default"].createElement(UnblockTip, {
          isDomain: isDomain,
          onClick: onUnblock,
          disabled: disabled
        });
      } else {
        return /*#__PURE__*/_react["default"].createElement(BlockButton, {
          isDomain: isDomain,
          onClick: onBlock,
          disabled: disabled
        });
      }
    }
    return null;
  }, [showBlockAction, disabled, blocked]);
  var hideImagesAction = (0, _react.useMemo)(function () {
    if (showHideImageAction) {
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(HideImagesButton, {
        onClick: onHideImages,
        disabled: disabled
      }));
    }
    return null;
  }, [showHideImageAction, disabled]);
  var shouldShowSeparator = showBlockAction && !blocked && showHideImageAction;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col items-center leading-relaxed"
  }, /*#__PURE__*/_react["default"].createElement("div", null, avatar ? ( /*#__PURE__*/_react["default"].cloneElement(avatar, {
    className: '!w-20 !h-20 text-3xl'
  })) : /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    alt: name,
    className: "!w-20 !h-20 text-3xl"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold text-2xl text-gray-dark"
  }, name), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm text-gray-light"
  }, email), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex justify-center items-center', {
      'flex-col': !shouldShowSeparator,
      'flex-row': shouldShowSeparator
    })
  }, blockAction, shouldShowSeparator ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-primary text-xs font-semibold"
  }, "\xA0\xB7\xA0") : null, hideImagesAction));
}
//# sourceMappingURL=ContactInfo.js.map